export const GET_RESTAURANTS_REQUEST = "GET_RESTAURANTS_REQUEST";
export const GET_RESTAURANTS_SUCCESS = "GET_RESTAURANTS_SUCCESS";
export const GET_RESTAURANTS_FAILURE = "GET_RESTAURANTS_FAILURE";

export const GET_SINGLE_RESTAURANT_REQUEST = "GET_SINGLE_RESTAURANT_REQUEST";
export const GET_SINGLE_RESTAURANT_SUCCESS = "GET_SINGLE_RESTAURANT_SUCCESS";
export const GET_SINGLE_RESTAURANT_FAILURE = "GET_SINGLE_RESTAURANT_FAILURE";

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const EMPTY_CART = "EMPTY_CART";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
